import { render, staticRenderFns } from "./HowToUseImage.vue?vue&type=template&id=b147380e&scoped=true&"
var script = {}
import style0 from "./HowToUseImage.vue?vue&type=style&index=0&id=b147380e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b147380e",
  null
  
)

export default component.exports